import React, { PropTypes } from 'react';
import moment from 'moment';

import {DeliveryRow, DeliveryItem, Label, Value} from './Styled';

const formatDate = (date) => {
  if (date) return moment(date).format('DD/MM/YYYY');
  else return 'N/A';
};

const Delivery = ({ address, name, phone, date, action }) => (

  <div>
    <DeliveryRow>
      <DeliveryItem>
        <Label>Address</Label>
        <Value>{address}</Value>
      </DeliveryItem>
    </DeliveryRow>

    <DeliveryRow>
      <DeliveryItem>
        <Label>Contact Name</Label>
        <Value>{name}</Value>
      </DeliveryItem>
    </DeliveryRow>

    <DeliveryRow>
      <DeliveryItem>
        <Label>Contact number</Label>
        <Value>{phone}</Value>
      </DeliveryItem>
      <DeliveryItem>
        <Label>Date required</Label>
        <Value>{formatDate(date)}</Value>
      </DeliveryItem>
    </DeliveryRow>

  </div>
);

Delivery.propTypes = {
  action: PropTypes.func,
  address: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  date: PropTypes.string
};

export default Delivery;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/Delivery.js